module.exports = __webpack_public_path__ + "media/images/icons/key-2a28404feac475954cc27660e7408637.svg";